'use client';

import Link from 'next/link';
import { SITE_PAGE_BODY } from '@/platform/layout';
import {
  type JoinGateError,
  joinGateCopy,
  joinRequestHref,
  JOIN_GATE_APPROVAL,
} from './joinGate';

export function JoinGateAlert({ error }: { error: JoinGateError }) {
  const copy = joinGateCopy(error.code);
  const href =
    typeof window !== 'undefined' ? joinRequestHref(window.location.hostname) : '/saas/start/';

  return (
    <div className={SITE_PAGE_BODY.error} data-testid="join-gate-alert" role="alert">
      <p>{error.message || copy.body}</p>
      {error.code === JOIN_GATE_APPROVAL ? (
        <p>
          <Link href={href} className={SITE_PAGE_BODY.btnPrimary} data-testid="join-gate-request">
            Request to join
          </Link>
        </p>
      ) : null}
    </div>
  );
}
